var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoRaces(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cat-title",
    transform: "translate(-241 -33)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(241 33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.792c-7.329 0-13.292-5.963-13.292-13.292S7.171 1.208 14.5 1.208 27.792 7.171 27.792 14.5 21.829 27.792 14.5 27.792M14.5 0C6.492 0 0 6.492 0 14.5S6.492 29 14.5 29 29 22.508 29 14.5 22.508 0 14.5 0",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.852 8c-.97 0-1.913.323-2.657.91a3.978 3.978 0 00-1.13 1.411c-.161.338-.01.74.332.897a.69.69 0 00.91-.327 2.61 2.61 0 01.745-.927 2.91 2.91 0 011.8-.613c1.531 0 2.776 1.152 2.776 2.568 0 1.33-1.078 2.43-2.508 2.556a3.15 3.15 0 01-.268.011h-.013a.682.682 0 00-.686.676v2.162c0 .373.308.676.686.676a.681.681 0 00.686-.676v-1.549C16.545 15.467 18 13.863 18 11.92 18 9.758 16.14 8 13.852 8",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21a.5.5 0 100 1 .5.5 0 000-1",
    id: "Fill-5"
  })))))));
}

SvgInfoRaces.displayName = 'InfoRaces';
export default SvgInfoRaces;